import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EmpresaInserirComponent } from './empresa-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: EmpresaInserirComponent }
    ])],
    exports: [RouterModule]
})
export class EmpresaInserirRoutingModule { }
